import useMobile from '../../hooks/useMobile';
import styles from './Stepper.module.scss';

function Stepper(props) {
  const { onStepChange, currentStep } = props;
  const isMobile = useMobile();
  const stepperSteps = ["1", "2", "3"];

  const handleClickStepButton = (step) => {
    const item = parseInt(step);
    if (currentStep === 3 && (item === 2 || item === 1)) {
      onStepChange(item)
    } else if (currentStep === 2 && item === 1) {
      onStepChange(item)
    }
  }


  return (
    // <div style={{width: "calc(100% - 100px)"}}>
    <div style={{width: "100%"}}>
        <div className={styles["step-list"]}>
          {
            stepperSteps.map((item, index)=>{
              return  <div 
                        key={item} 
                        className={styles['step']} 
                        isdone={props.currentStep>=index+2 ? 'yes' :'no'} 
                        isactive={props.currentStep===index+1 ? 'yes' :'no'}
                        isBetween1and2={props.currentStep === 1.2 && index < 1 ? 'yes' :'no'}
                        islast={props.currentStep===stepperSteps.length ? 'yes' :'no'}
                      >
                        <button onClick={()=> handleClickStepButton(item)} className={styles["step-button"]}>
                          {item}
                        </button>
                      </div>
            })
          }
        </div>
    </div>
  );
}

export default Stepper;
